import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import OrderController, { KnockOrderLandingItemType } from '../controller/OrderController';
import { langState } from '../recoil/lang';
import OrderQrStatus from './OrderQrStatus';
import StaffConfirm from './StaffConfirm';
import OrderCancelModal from '../components/modal/OrderCancelModal';
import OrderStaffModal from '../components/modal/OrderStaffModal';
import OrderRollbackModal from '../components/modal/OrderRollbackModal';
import { useToast } from '../controller/ToastController';

const OrderStatusMain = () => {
  const showToast = useToast();
  let oParams = useParams();
  const orderId = oParams.order_id;
  const [lang, setLang] = useRecoilState<number>(langState);
  const [orderData, setOrderData] = useState<KnockOrderLandingItemType>();
  const [orderType, setOrderType] = useState<string>('');
  const [orderStatus, setOrderStatus] = useState<string>('');
  const [numberTemp, setNumberTemp] = useState<string>('');
  const [visibleCancel, setVisibleCancel] = useState<boolean>(false);
  const [visibleStaff, setVisibleStaff] = useState<boolean>(false);
  const [visibleRollback, setVisibleRollback] = useState<boolean>(false);

  const getCategoryLabel = (orderCategory: number) => {
    if (orderCategory === 0) {
      return 'ORDER_CATEGORY_NORMAL';
    } else if (orderCategory === 1) {
      return 'ORDER_CATEGORY_TIME ';
    } else if (orderCategory === 2) {
      return 'ORDER_CATEGORY_ROOM';
    } else if (orderCategory === 3) {
      return 'ORDER_CATEGORY_TIME_DELIVERY';
    } else if (orderCategory === 4) {
      return 'ORDER_CATEGORY_TIME_SENDMAIL';
    } else {
      return '';
    }
  };
  const getOrderStatus = (orderStatus: number) => {
    if (orderStatus === 0) {
      return 'ORDER_WATING';
    } else if (orderStatus === 1) {
      return 'ORDER_READY';
    } else if (orderStatus === 2) {
      return 'ORDER_COOKING_COMPLETE';
    } else if (orderStatus === 3) {
      return 'ORDER_SERVING_COMPLETE';
    } else if (orderStatus === 4) {
      return 'ORDER_CANCEL';
    } else if (orderStatus === 5) {
      return 'ORDER_SUCCESS';
    } else if (orderStatus === 6) {
      return 'ORDER_DELIVERY_START';
    } else if (orderStatus === 7) {
      return 'ORDER_DELIVERY_SUCCESS';
    } else {
      return '';
    }
  };

  const getOrderByOrderId = async () => {
    try {
      if (orderId) {
        const oData = {
          order_id: orderId,
        };
        const response = await OrderController.getOrderByOrderId(oData);

        if (response.data.ok) {
          const orderCategory = response.data.data.order.child[0].order_category;
          const orderStatus = response.data.data.order.child[0].order_status;
          setOrderData(response.data.data.order);
          setOrderType(getCategoryLabel(orderCategory));
          setOrderStatus(getOrderStatus(orderStatus));
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const requestCancel = async () => {
    try {
      if (orderId) {
        const oData = {
          order_id: orderId,
        };
        const response = await OrderController.requestCancel(oData);

        if (response.data.ok) {
          setVisibleCancel(false);
          getOrderByOrderId();
        } else {
          setVisibleCancel(false);
          showToast(response.data.msg, 'error');
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const cancelCustomer = async () => {
    try {
      if (orderId) {
        const response = await OrderController.cancelCustomer(orderId, 0);

        if (response.data.success) {
          console.log('response.data.ok>>', response.data.ok);
          setVisibleCancel(false);
          getOrderByOrderId();
        } else {
          showToast('오류입니다. 다시 시도해주세요.', 'error');
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const completeOrderStaff = async () => {
    try {
      if (orderId) {
        const oData = {
          order_id: orderId,
          order_seq: 0,
        };
        const response = await OrderController.completeOrderStaff(oData);

        if (response.data.ok) {
          setVisibleStaff(false);
          getOrderByOrderId();
        } else {
          showToast('다시 시도해주세요.', 'error');
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const rollbackOrder = async () => {
    try {
      if (orderId) {
        const oData = {
          order_id: orderId,
          confirm_password: numberTemp,
        };
        const response = await OrderController.rollbackOrder(oData);

        if (response.data.ok) {
          setVisibleRollback(false);
          getOrderByOrderId();
        } else {
          showToast('비밀번호가 틀렸습니다. 다시 확인해 주세요.', 'error');
        }
        setNumberTemp('');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getOrderByOrderId();
  }, []);
  useEffect(() => {
    if (orderData) {
      setLang(orderData.child[0].lang);
    }
  }, [orderData]);

  return (
    <Style>
      <div className="wrap">
        {orderType === 'ORDER_CATEGORY_NORMAL' && (
          <OrderQrStatus
            orderData={orderData}
            orderStatus={orderStatus}
            lang={lang}
            setLang={setLang}
            refresh={getOrderByOrderId}
            setVisibleCancel={setVisibleCancel}
          />
        )}
        {orderType === 'ORDER_CATEGORY_TIME_SENDMAIL' && (
          <StaffConfirm
            orderData={orderData}
            orderStatus={orderStatus}
            setVisibleCancel={setVisibleCancel}
            setVisibleStaff={setVisibleStaff}
            setVisibleRollback={setVisibleRollback}
            lang={lang}
            setLang={setLang}
          />
        )}
      </div>
      <OrderCancelModal
        isOpen={visibleCancel}
        onCancel={() => setVisibleCancel(false)}
        onSuccess={orderType === 'ORDER_CATEGORY_TIME_SENDMAIL' ? requestCancel : cancelCustomer}
        lang={lang}
      />
      <OrderStaffModal
        isOpen={visibleStaff}
        onCancel={() => setVisibleStaff(false)}
        onSuccess={completeOrderStaff}
      />
      <OrderRollbackModal
        isOpen={visibleRollback}
        onCancel={() => setVisibleRollback(false)}
        onSuccess={rollbackOrder}
        numberTemp={numberTemp}
        setNumberTemp={setNumberTemp}
      />
    </Style>
  );
};

export default OrderStatusMain;

export const Style = styled.div``;
